const CLARITY_PROJECT_ID = 'yg6fyefxqh';
const META_PIXEL_ID = '28186268544390310';

type QueuedFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  q?: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: (...args: unknown[]) => void;
};

type AnalyticsWindow = Window & {
  clarity?: QueuedFunction;
  fbq?: QueuedFunction;
  _fbq?: QueuedFunction;
};

const isPublishedDomain = () =>
  /(^|\.)garciavidal\.com$/.test(window.location.hostname)
  || /(^|\.)familiagarciavidal\.com$/.test(window.location.hostname);

const loadClarity = () => {
  const analyticsWindow = window as AnalyticsWindow;
  if (analyticsWindow.clarity || document.querySelector('[data-clarity-script]')) return;

  const clarity: QueuedFunction = (...args: unknown[]) => {
    clarity.q = clarity.q || [];
    clarity.q.push(args);
  };
  analyticsWindow.clarity = clarity;
  clarity('consentv2', { ad_Storage: 'granted', analytics_Storage: 'granted' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  script.dataset.clarityScript = 'true';
  document.head.appendChild(script);
};

const loadMetaPixel = () => {
  const analyticsWindow = window as AnalyticsWindow;
  if (analyticsWindow.fbq || document.querySelector('[data-meta-pixel-script]')) return;

  const fbq: QueuedFunction = (...args: unknown[]) => {
    if (fbq.callMethod) fbq.callMethod(...args);
    else {
      fbq.queue = fbq.queue || [];
      fbq.queue.push(args);
    }
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  analyticsWindow.fbq = fbq;
  analyticsWindow._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixelScript = 'true';
  document.head.appendChild(script);

  fbq('init', META_PIXEL_ID);
  fbq('track', 'PageView');
};

export const loadAnalytics = () => {
  if (!isPublishedDomain()) return;
  loadClarity();
  loadMetaPixel();
};
